import React from 'react';

export const ContractGondola: React.FC = () => null;
